import { useContext, useState, useEffect, useRef } from 'react';
import PageContext from './PageContext';
import redMinusIcon from '../../svgs/delete-bin-icon.svg';
import DynamicTableInput from './DynamicTableInputCopy.jsx'; 
import addIcon from '../../svgs/plus-icon.svg';
import { Button, TableCell, Typography } from '@mui/material';
import isNullOrUndefined from '../functions/isNullOrUndefined.js'; 

const AddNewPayoutInfoRow = ({ data, setData, count, config, length, setLength, lists, error, setError, show=true })=> {
    // get context variables from parent
    const { 
        masterPayoutInfoBool, 
        payoutMethodList, 
        subCompanyIdsList
    } = useContext(PageContext);

    // initialize state 
    const [showAchInfo, setShowAchInfo] = useState(true); 

    // get minimum width
    const getMinWidth = (el, key) => {
        if (isNullOrUndefined(el[key])) {
            return '100%'
        }
        return el[key]; 
    }

    // check whether ach type will clear ach info. If clears info return false so ach info does not show on modal
    const checkShowAchInfo = (method) => {
        // find method in payoutMethodData
        for (let i = 0; i < payoutMethodList.length; i++){
            if (payoutMethodList[i]['id'] == method['id']){
                console.log(!payoutMethodList[i]['clearachinfo']); 
                // return !clearachinfo to determine whether it should be shown in modal 
                setShowAchInfo(showAchInfo => showAchInfo = !payoutMethodList[i]['clearachinfo']); 
                return !payoutMethodList[i]['clearachinfo']; 
            }
        }
        // default return is true 
        setShowAchInfo(showAchInfo => showAchInfo = true); 
        return true; 
    }

    // add payout info 
    const addPayoutInfo = () => {
        console.log(data); 

        let temp2 = []; 
        for (let i = 0; i < config.length; i++){
            temp2.push(config[i]['columnid']);
        }
        let temp;
        temp2.map((el) => {
            if (el === 'blank'){
                temp = {...temp, [el]: false};
            }
            else if (el === 'active'){
                temp = {...temp, [el]: lists['active'][0]};
            }
            else{
                temp = {...temp, [el]: ''};
            }
        });
        // add new row to object
        let tempObj = data; 
        // move bottom row to end of object
        tempObj[(count+1)] = data[count]; 
        // set new element
        tempObj[count] = temp;
        // assign to state
        setData(data => data = tempObj);
        // update length
        setLength(length => length = length+1); 
        // set error object 
        let temp5 = {}
        Object.keys(temp2).map((el) => {
            temp5 = {
                ...temp5, 
                el: false, 
            }
        }); 
        // add error object to sub company error list 
        setError(error => error = [
            ...error.slice(0, error.length-1), 
            temp5, 
            ...error.slice(error.length-1, error.length)
        ]); 
    }
    // remove row from data list 
    const removePayoutInfo = () => {
        console.log(data); 
        // set tempObj to make changes
        let tempObj = data; 
        // remove row at count
        let length = 0; 
        Object.keys(tempObj).map(el => {
            let num = parseInt(el); 
            // set length; 
            length = num; 
            // overwrite element
            if (tempObj[(num+1)] && num >= count) {
                tempObj[num] = tempObj[(num+1)]; 
            }
        }); 
        // remove last element 
        delete tempObj[length]; 
        // set state 
        setData(data => data = tempObj); 
        // update length
        setLength(length => length = length-1); 
        // set state 
        setData(data => data = tempObj);
        // remove error object from error list
        setError(error => error = [...error.slice(0, count), ...error.slice(count + 1, error.length)]); 
    }

    // useEffect for masterPayoutInfoBool toggle
    useEffect(() => {
        // if masterPayoutInfoBool is true make companyid master company placeholder 
        if (masterPayoutInfoBool){
            let tempObj = data; 
            tempObj[count]['companyid'] = process.env.REACT_APP_MASTER_PAYOUT_INFO_PLACEHOLDER; 
            tempObj[count]['active'] = lists['active'][0]; 
            setData(data => data = tempObj); 
        }
        // if changing back to sub company payout info clear sub company id 
        else {
            let tempObj = data; 
            tempObj[count]['companyid'] = ''; 
            tempObj[count]['active'] = lists['active'][0]; 
            setData(data => data = tempObj); 
        }
    }, [masterPayoutInfoBool]); 

    return( 
        <>
            {/* order columns according to config object */}
            { config && data[count] ? 
                config.map(el =>
                show && el['columnid'] !== 'blank' && data[count]['blank'] !== true
                && el['columnid'] !== 'companyid' ?
                <TableCell>
                    {console.log(count + ': ' + error[count])}
                    <DynamicTableInput 
                        count={count}
                        length={length}
                        data={data} 
                        setData={setData} 
                        config={el} 
                        args={lists} 
                        // width={'100%'} 
                        showError={error[count][el['columnid']]}
                        onChangeFunction={()=>{return}}
                        // minWidth={el['width']}
                        width={getMinWidth(el, 'width')}
                    />
                </TableCell>
                : show && el['columnid'] !== 'blank' && data[count]['blank'] !== true
                && el['columnid'] === 'companyid' && masterPayoutInfoBool !== true ?
                <TableCell>
                    {console.log(count + ': ' + error[count])}
                    <DynamicTableInput 
                        count={count}
                        length={length}
                        data={data} 
                        setData={setData} 
                        config={el} 
                        args={{companyid: subCompanyIdsList}} 
                        // width={'100%'} 
                        showError={error[count][el['columnid']]}
                        onChangeFunction={()=>{return}}
                        // minWidth={el['width']}
                        width={getMinWidth(el, 'width')}
                    />
                </TableCell>
                : show && el['columnid'] !== 'blank' && data[count]['blank'] !== true
                && el['columnid'] === 'companyid' && masterPayoutInfoBool === true ?
                <TableCell>
                    {/* Don't show companyid autoselect if adding mastercompanyid payout info */}
                </TableCell>
                : show && el['columnid'] === 'blank' && data[count]['overrideblank'] !== true && data[count]['blank'] === true ? 
                <TableCell colSpan={config.length} align='center' sx={{padding:0}}>
                    <div className='p-2 bg-white'>
                        <Button disableRipple onClick={()=>addPayoutInfo()} 
                        sx={{width:'100%', background:'#E5F2F6' ,border:'#E5F2F6','&:hover': {
                            backgroundColor: '#D9ECF2',
                            },
                            }}
                        >
                            {<div className='d-flex gap-2 align-items-center p-1'>
                                <img src={addIcon}/>
                                <Typography sx={{
                                    textTransform:'none',
                                    color:'#001317',
                                    fontFamily:'Roboto regular, Helvetica, Arial, sans-serif',
                                    fontSize:'12px',
                                    lineHeight:'16px',
                                    fontWeight:'400'}}>
                                        {'Add'}
                                </Typography>
                            </div>}
                        </Button>
                    </div>          
                </TableCell>
                : show && el['columnid'] === 'blank' && data[count]['overrideblank'] !== true && data[count]['blank'] !== true ?
                <TableCell>
                    <img src={redMinusIcon} class='data-table-icon-right' onClick={()=>removePayoutInfo()}/>
                </TableCell>
                : show && el['columnid'] === 'blank' && data[count]['overrideblank'] === true && data[count]['blank'] !== true ?
                    <TableCell></TableCell> // TODO: Check this condition
                :<></>
            )
            :<TableCell></TableCell>}
        </>
    );
}

export default AddNewPayoutInfoRow; 